import {
  CommandeMaterielDto,
  ICommandeMaterielWebServiceClient
} from '@resources/resources';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class HistoriqueDetailResolver implements Resolve<CommandeMaterielDto> {

  constructor(private commandeWebService: ICommandeMaterielWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id: number = Number(route.paramMap.get('id'));
    let commande = this.commandeWebService.getHistoriqueCommande(id);
    return commande;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/historique-detail/historique-detail.resolver.ts